import { CircularProgress, Grid, Stack } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import { DownloadTreeAttachment, GetBase64OfFiles } from 'src/components/services/httpServices';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  borderRadius: '25px',
  boxShadow: 24,
  p: 4,
};

export default function PdfViewerModal(props) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState('');

  const handleOpen = () => {
    GetAttachment(props.selectedNode, props.file, props.filePath);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // console.log('props', props);
  const fetchAttachment = async (path) => {
    payload = {
      code: 'path',
      value: path,
    };
    var file = await GetBase64OfFiles(payload);
    setFile(file);
    setLoading(false);
  };
  const GetAttachment = async (node, fileName, path) => {
    //var file = await DownloadAttachment(path);
    var file = null;
    if (node != null) {
      file = await DownloadTreeAttachment('1', false, node?.name, node?.path, true);
    } else {
      // file = await DownloadAttachment(fileName);
      file = await DownloadTreeAttachment('1', false, '', path, false);
    }

    //console.log('FILE:;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;', file);

    const blob = new Blob([file?.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    setFile(url);
    setLoading(false);
  };
  console.log('props.file:', props.file.substr(props.file.length - 3));
  return (
    <div>
      {props.component ? (
        <Button onClick={handleOpen}>{props.component}</Button>
      ) : props.treeView == true ? (
        <Stack direction="row" onClick={handleOpen}>
          <Iconify icon={props.icon} sx={{ mr: 2 }} />
          <Typography variant="subtitle2">{props.title}</Typography>
        </Stack>
      ) : (
        <Button variant={props.variant ? props.variant : 'text'} onClick={handleOpen}>
          {props.title}
        </Button>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            {loading ? (
              <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
                <CircularProgress size={60} thickness={3} value={100} />
              </Grid>
            ) : props.file.substr(props.file.length - 3) == 'pdf' ||
              props.file.substr(props.file.length - 3) == 'PDF' ? (
              <object title="File Viewer" data={file} width="100%" height="700px" frameBorder="0"></object>
            ) : (
              <Typography variant="h6" color="initial">
                <span style={{ color: '#ad1f22' }}>Please Download the document You can only View Pdf here.</span>
              </Typography>
            )}

            <Stack direction="row" spacing={4} flexDirection="row-reverse" marginTop={1}>
              <Button onClick={handleClose} variant="contained">
                Close
              </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
